import { useIntl } from 'react-intl'
import { NewsReactionType } from '@models/news'
import NewsItemCta from '../NewsItemCta/NewsItemCta'
import { LuxReactionPicker } from '@lux/wardrobe-lib'

const NewsItemCtaContainer = (props: {
    id: string
    showComments: boolean
    enableCommentsAndReactions: boolean
    isCommentListLoading?: boolean
    updateTotalReactions: (id: string, reaction: string) => void
    onComment: () => void
    onCopyLink: () => void
}) => {
    const {
        id,
        showComments,
        isCommentListLoading,
        enableCommentsAndReactions,
        updateTotalReactions,
        onCopyLink,
    } = props

    const intl = useIntl()

    const newsItemCtaContainerClass = 'home-news-item-cta-container'
    const reactionHandler = (type: NewsReactionType) => {
        updateTotalReactions(id, type)
    }

    const ctaCommentsHandler = () => {
        props.onComment()
    }

    return (
        <div className={`${newsItemCtaContainerClass}${showComments ? ' show-comments' : ''}`}>
            <div className="home-news-item-cta">
                {enableCommentsAndReactions && (
                    <LuxReactionPicker
                        label="Like"
                        icon="thumb-up"
                        onSelectReaction={reactionHandler}
                    />
                )}
            </div>

            <div>
                {enableCommentsAndReactions && (
                    <NewsItemCta
                        title={intl.formatMessage({
                            id: showComments ? 'home.news.close.comment' : 'home.news.open.comment',
                            defaultMessage: 'Comment',
                        })}
                        icon="comment"
                        rightIcon={showComments ? 'caret-down' : 'caret-up'}
                        onClick={ctaCommentsHandler}
                        disabled={isCommentListLoading}
                    />
                )}
            </div>
            <NewsItemCta
                title={intl.formatMessage({
                    id: 'copy_link',
                    defaultMessage: 'Copy link',
                })}
                icon="copy"
                onClick={onCopyLink}
            />
        </div>
    )
}

export default NewsItemCtaContainer
